import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import SidebarIcon from '../components/SidebarIcon';
import './AdminDashboard.css';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isSuperAdmin = (user?.role || '').toLowerCase() === 'superadmin';

  return (
    <div className="admin-content">
      {/* Page Heading */}
      <h2 className="page-title">Dashboard</h2>

      {/* Action Cards */}
      <div className="admin-actions-grid">
        {isSuperAdmin && (
          <div className="admin-action-card" onClick={() => navigate('/admin/users')}>
            <div className="action-icon"><SidebarIcon name="users" size={28} color="var(--primary)" /></div>
            <h4>Admin Management</h4>
            <p>Manage all platform admins</p>
          </div>
        )}

        <div className="admin-action-card" onClick={() => navigate('/admin/candidates')}>
          <div className="action-icon"><SidebarIcon name="candidates" size={28} color="var(--primary)" /></div>
          <h4>Candidate Management</h4>
          <p>View and manage candidates</p>
        </div>

        {isSuperAdmin && (
          <div className="admin-action-card" onClick={() => navigate('/sadmin/scenarios')}>
            <div className="action-icon"><SidebarIcon name="questions" size={28} color="var(--primary)" /></div>
            <h4>Scenario Management</h4>
            <p>Create and manage scenarios</p>
          </div>
        )}

        <div className="admin-action-card" onClick={() => navigate('/admin/evaluation')}>
          <div className="action-icon"><SidebarIcon name="evaluation" size={28} color="var(--primary)" /></div>
          <h4>Candidate Evaluation</h4>
          <p>View results and analytics</p>
        </div>
      </div>
    </div>
  );
}
